<template>
  <div id="copyrightPC" class="copyrightPC">
    <div class="zy_constr">
      <img
        v-lazy="
          'https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/d86597f5-6c85-410c-b2c1-db883a4b85f1.png'
        "
        class="copyrightPC-bg"
        alt=""
      />
      <div class="copyrightPC-title">版权内容</div>
      <div class="copyrightPC-main">
        <Tabs class="tabs--dark" :tabs="tabs" :currentTab="currentTab" @onClick="handleClick" />
        <div class="copyrightPC-desc">
          <div class="copyrightPC-desc-item" v-for="desc in currentDesc" :key="desc">{{ desc }}</div>
        </div>
      </div>
      <div v-if="currentVisible" class="copyrightPC-book">
        <div
          class="copyrightPC-book_item copyrightPC-book_item--current"
          :style="{ animationDelay: `${Math.floor(index / 4) * 0.1 + (index % 4) * 0.1}s` }"
          v-for="(item, index) in currentBookList"
          :key="index"
        >
          <img :src="item || ''" />
        </div>
      </div>
      <div v-if="prevVisible" class="copyrightPC-book">
        <div
          class="copyrightPC-book_item copyrightPC-book_item--prev"
          :style="{ animationDelay: `${Math.floor(index / 4) * 0.1 + (index % 4) * 0.1}s` }"
          v-for="(item, index) in prevBookList"
          :key="index"
        >
          <img :src="item || ''" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { COPYRIGHT } from '@/config';
import Tabs from 'vue-tabs-with-active-line';

export default {
  name: 'copyrightPC',
  components: {
    Tabs
  },
  data: function () {
    const tabs = COPYRIGHT.map(item => ({
      title: item.name,
      value: item.id
    }));

    return {
      tabs,
      currentTab: '',
      prevBookList: [],
      currentVisible: true,
      prevVisible: false
    };
  },
  computed: {
    currentDesc() {
      return COPYRIGHT.find(item => item.id === this.currentTab)?.desc || '';
    },
    currentBookList() {
      return COPYRIGHT.find(item => item.id === this.currentTab)?.pics || [];
    }
  },
  mounted() {
    // 使用 Intersection Observer 检测组件进入可视区域
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 组件进入可视区域时，确保 currentTab 有初始值
          if (!this.currentTab && this.tabs.length > 0) {
            this.currentTab = this.tabs[0].value;
          }
          // 组件进入可视区域后，停止观察
          this.observer.unobserve(entry.target);
        }
      });
    });

    // 开始观察组件
    this.$nextTick(() => {
      const element = this.$el;
      if (element) {
        this.observer.observe(element);
      }
    });
  },
  beforeDestroy() {
    // 组件销毁前清理 observer
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    handleClick(value) {
      this.currentVisible = false;

      this.$nextTick(() => {
        this.prevBookList = [...this.currentBookList];
        this.currentTab = value;
        this.currentVisible = true;
        this.prevVisible = true;
      });

      setTimeout(() => {
        this.prevVisible = false;
      }, 800);
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/function.scss';
@import '@/styles/tabs.scss';

.copyrightPC {
  background-color: rgba(0, 0, 0, 0.85);
  height: 600px;
}

.zy_constr {
  position: relative;
}

.copyrightPC-bg {
  width: 836px;
  height: 600px;
  position: absolute;
  top: 0;
  left: -140px;
  z-index: -1;
}

.copyrightPC-title {
  color: #fff;
  font-size: 24px;
  line-height: 36px;
  font-weight: 500;
  padding-top: 80px;
}

.copyrightPC-main {
  margin-top: 48px;
  width: 556px;
  font-size: 0;
}

.copyrightPC-desc {
  padding-top: 24px;
  &-item {
    color: rgba(255, 255, 255, 0.85);
    line-height: 28px;
    font-size: 16px;
    margin-top: 12px;
  }
}

.copyrightPC-book {
  position: absolute;
  width: 504px;
  top: 50px;
  right: 0px;
  display: flex;
  flex-wrap: wrap;
}

.copyrightPC-book_item {
  width: 123px;
  height: 164px;
  flex-shrink: 0;
  position: relative;
  margin-left: 4px;
  margin-top: 4px;
  background-image: url('https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/89f4c940-918d-41f6-8698-d89234a00249.png');
  background-size: cover;

  &--current {
    animation: imageAppear 0.3s ease-out forwards;
  }
  &--prev {
    animation: imageExit 0.3s ease-out forwards;
  }

  &:nth-child(4n - 3) {
    margin-left: 0;
  }

  &:nth-child(-n + 4) {
    margin-top: 0;
  }

  img {
    width: 100%;
    height: auto;
    position: absolute;
    top: 0;
    left: 0;
  }
}

@keyframes imageAppear {
  0% {
    opacity: 0;
    transform: scale(1) translate(0, 0);
  }
  50% {
    transform: scale(1.1) translate(12px, -12px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translate(0, 0);
  }
}

@keyframes imageExit {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
